import { notification, Modal } from 'antd';

import { gwPost, gwGet } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { handleGwData, setPostBody } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import makeOrCacheApiReq from '../../utils/apiCache';

const {
  GET_SIMPLEX_QUORE,
  GET_SIMPLEX_QUORE_SUCCESS,
  GET_SIMPLEX_QUORE_ERROR,
  GET_KOINAL_QUORE_ERROR,
  SEND_PAYMENT_REQUEST,
  SEND_PAYMENT_REQUEST_SUCCESS,
  SEND_PAYMENT_REQUEST_ERROR,
  CHECK_SIMPLEX_STATUS_SUCCESS,
  CHECK_SIMPLEX_STATUS_ERROR,
  GET_SIMPLEX_CURRENCY_LIST_SUCCESS,
  GET_SIMPLEX_CURRENCY_LIST_ERROR,
  GET_GATEWAY_CHANNEL_SUCCESS,
  GET_GATEWAY_CHANNEL_ERROR,
} = actionTypes;

const setQuoteInfo = createBaseActions(GET_SIMPLEX_QUORE_SUCCESS, 'data');
const setPaymentRequestData = createBaseActions(SEND_PAYMENT_REQUEST_SUCCESS, 'data');
const setSimplexStatus = createBaseActions(CHECK_SIMPLEX_STATUS_SUCCESS, 'data');
const setSimplexCurrencyList = createBaseActions(GET_SIMPLEX_CURRENCY_LIST_SUCCESS, 'data');
const setGatewayChannel = createBaseActions(GET_GATEWAY_CHANNEL_SUCCESS, 'data');

// koinal接口返回报错专用code，有特殊逻辑
const KOINAL_ERROR_CODE = '200000000';

export const getSimplexQuote = (postData, locale, message) => async dispatch => {
  dispatch({ type: GET_SIMPLEX_QUORE });
  try {
    const data = await gwPost(API_PATH.GET_SIMPLEX_QUORE, setPostBody(postData));
    if (data.success) {
      dispatch(setQuoteInfo(handleGwData(data)));
    } else if (data.code === KOINAL_ERROR_CODE) {
      dispatch({ type: GET_KOINAL_QUORE_ERROR, data: data.message });
    } else {
      Modal.warning({
        title: locale === 'cn' ? '警告' : 'WARNING',
        content: message,
        okText: locale === 'cn' ? '返回' : 'Back',
        onOk: () => window.location.href = `/${locale}/buy-sell-crypto`, // eslint-disable-line
      });
    }
  } catch (error) {
    notification.error({
      message: 'Failed to get new quote',
    });
    dispatch({ type: GET_SIMPLEX_QUORE_ERROR, error });
  }
};

export const checkWhiteUser = (locale, message) => async () => {
  try {
    const data = await gwGet(API_PATH.CHECK_WHITE_LIST_USER);
    if (!data.success && !data.data) {
      Modal.warning({
        title: locale === 'cn' ? '警告' : 'WARNING',
        content: message,
        okText: locale === 'cn' ? '返回' : 'Back',
        onOk: () => window.location.href = `/${locale}/buy-sell-crypto`, // eslint-disable-line
      });
      return false;
    }
  } catch (error) {
    notification.error({
      message: 'Failed to get user check',
    });
  }
  return true;
};

export const sendPaymentRequest = postData => async dispatch => {
  dispatch({ type: SEND_PAYMENT_REQUEST });
  try {
    const data = await gwPost(API_PATH.SEND_PAYMENT_REQUEST, setPostBody(postData));
    if (data.success) {
      dispatch(setPaymentRequestData(handleGwData(data)));
    } else {
      notification.error({
        message: data.message,
      });
    }
  } catch (error) {
    notification.error({
      message: 'Network is not good, Please try later.',
    });
    dispatch({ type: SEND_PAYMENT_REQUEST_ERROR, error });
  }
};

export const checkSimplexStatus = async (req, store, params) => {
  try {
    let api = API_PATH.CHECK_SIMPLEX_STATUS;
    if (params && params.channelName) {
      api = `${api}?channelName=${params.channelName}`;
    }
    const data = await makeOrCacheApiReq(api, () => gwGet(api, {}, req), res => res.success);
    store.dispatch(setSimplexStatus(handleGwData(data)));
  } catch (error) {
    store.dispatch({ type: CHECK_SIMPLEX_STATUS_ERROR, error });
  }
};

export const getSimplexCurrencyList = async (req, store, postData) => {
  try {
    const api = API_PATH.GET_SIMPLEX_CURRENCY_LIST;
    const data = await gwPost(api, setPostBody(postData), req);
    store.dispatch(setSimplexCurrencyList(handleGwData(data)));
  } catch (error) {
    store.dispatch({ type: GET_SIMPLEX_CURRENCY_LIST_ERROR, error });
  }
};

export const getGatewayChannel = async (req, store) => {
  try {
    const api = API_PATH.GATEWAY_CHANNEL;
    const data = await makeOrCacheApiReq(api, () => gwGet(api, {}, req), res => res.success);
    store.dispatch(setGatewayChannel(handleGwData(data)));
  } catch (error) {
    // store.dispatch(setGatewayChannel(handleGwData({})));
    store.dispatch({ type: GET_GATEWAY_CHANNEL_ERROR, error });
  }
};

export default {};
